import type { CmsPageResponse } from "@/features/cms";
import type { EcommerceProduct } from "@/shared";

import type { Facet, FilterItem } from "./filters.type";

export type CatalogProduct = Omit<EcommerceProduct, "images" | "seller"> & {
  url: string;
  seller?: {
    type: string;
    name: string;
  };
  sponsor?: {
    is_sponsored: boolean;
    tracking_data: string;
  };
  tags?: {
    is_free_shipping: boolean;
    is_full_delivery: boolean;
    is_new: boolean;
  };
  images: {
    url: string;
  }[];
};

export type CatalogSort =
  | "price_asc"
  | "price_desc"
  | "discount_desc"
  | "novelty"
  | "popular";

export const DEFAULT_CATALOG_SORT: CatalogSort = "popular";

export type CatalogProductsRequest = {
  path: string;
  sort?: CatalogSort;
  pagination?: {
    page: number;
    per_page?: number;
  };
  is_cms_path?: boolean;
  filters?: FilterItem[];
};

export type CatalogProductsResponse = {
  pagination: {
    page: number;
    per_page: number;
    total: number;
    total_pages: number;
  };
  products: CatalogProduct[];
  facets?: Facet[];
};

export type CatalogMetaRequest = {
  path: string;
  filters?: FilterItem[];
};

export type CatalogMetaResponse = {
  breadcrumbs?: Array<{
    name: string;
    key: string;
    url: string;
  }>;

  header: {
    sorting: Array<{
      label: string;
      value:
        | "novelty"
        | "popular"
        | "price_asc"
        | "price_desc"
        | "discount_desc";
      tracking_value: string;
    }>;
  };

  cms?: CmsPageResponse;

  tracking_context?: {
    catalog_segment: string[];
  };
};
